import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CartService, CountriesService } from '@app/_services';
import * as _ from 'lodash';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Support, TranslateHelper } from '@app/_helpers';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { GoogleMap } from '@angular/google-maps';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-address-form',
    templateUrl: './address-form.component.html',
    styleUrls: ['./address-form.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, NgIf, NgFor, TranslateModule]
})
export class AddressFormComponent implements OnInit {



    @Input() addressData: any = {};
    @Input() isGuest = false;
    @Input()
    form = this.fb.group({
        _id: [null],
        ...(this.isGuest ? {} : { title: [null, [Validators.required]] }),
        name: [null, [Validators.required]],
        phone: [null, [Validators.required]],
        country: [null, [Validators.required, Validators.pattern(/[^((?!null).)*$]/)]],
        countryId: [null],
        area: [null],
        areaId: [null],
        city: [null, [Validators.required, Validators.pattern(/[^((?!null).)*$]/)]],
        cityId: [null],
        address1: [null],
        address2: [null],
        location: this.fb.group({
            longitude: [50.5440691369832],
            latitude: [26.1005374683495],
        }),
        building: [null, [Validators.required]],
        block: [null, [Validators.required]],
        flat: [null],
        road: [null, [Validators.required]],
        governorate: [null]
    });
    @Output() changeCityEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() location = new EventEmitter<any>()
    @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
    @ViewChild('search') public searchElementRef: ElementRef;


    sortBy = Support.sortBy;

    apiLoaded: Observable<boolean>;
    address: string;
    lang;
    type;
    userId;
    countries = [];
    country;
    zoom = 12;
    lng = 50.5440691369832;
    lat = 26.1005374683495;
    center: google.maps.LatLngLiteral = { lat: this.lat, lng: this.lng };
    options: google.maps.MapOptions = {
        zoomControl: true,
        scrollwheel: true,
        disableDoubleClickZoom: false,
        mapTypeId: "roadmap",
        disableDefaultUI: true,
        //maxZoom: 15,
        //minZoom: 8,
    };

    marker = {
        position: this.center,
        label: {
            color: "red",
        },
        options: {
            //animation: google.maps.Animation.DROP,
        },
    };;
    private geoCoder;

    constructor(private countriesService: CountriesService,
        private fb: UntypedFormBuilder,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private cartService: CartService,
        private ngZone: NgZone,
        private httpClient: HttpClient,


    ) {
        //check if api loaded
        if ('google' in window && typeof google === 'object' && typeof google.maps === 'object') {
            this.apiLoaded = of(true);
        } else {
            this.apiLoaded = httpClient
                .jsonp(
                    "https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyBzkxBu18nslVR_k36rBAf8A-YjEEGTvGY",
                    "callback"
                )
                .pipe(
                    map(() => true),
                    catchError((e) => {
                        return of(false)
                    }),
                    tap(res => {
                        if (res == false) return;

                        this.geoCoder = new google.maps.Geocoder;
                        let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
                        autocomplete.setComponentRestrictions({
                            country: ["bh"],
                        });
                        autocomplete.addListener("place_changed", () => {
                            this.ngZone.run(() => {
                                let place: google.maps.places.PlaceResult = autocomplete.getPlace();

                                if (place.geometry === undefined || place.geometry === null) {
                                    return;
                                }

                                this.form.get("location").get("longitude").setValue(place.geometry.location.lng());
                                this.form.get("location").get("latitude").setValue(place.geometry.location.lat());

                                this.center = {
                                    lng: place.geometry.location.lng(),
                                    lat: place.geometry.location.lat(),
                                };
                                this.marker.position = this.center;
                                this.zoom = 12;
                            });
                        });

                    })
                );
        }
    }

    ngOnInit(): void {

        this.center = {
            lng: parseFloat(this.addressData?.location?.longitude || this.form.get("location")?.get("longitude")?.value || 50.5440691369832),
            lat: parseFloat(this.addressData?.location?.latitude || this.form.get("location")?.get("latitude")?.value || 26.1005374683495),
        };
        this.marker =
        {
            position: this.center,
            label: {
                color: "red",
            },
            options: {
                //animation: google.maps.Animation.DROP,
            },
        };


        this.lang = this.translate.currentLang ?? 'en';
        if (this.addressData) this.fillForm();
        this.countriesService.getActiveCountries().subscribe(
            (countries) => {
                this.countries = countries;
                if (this.addressData?.countryId) {
                    this.selectCountry(this.addressData?.countryId);
                } else if (this.addressData?.country) {
                    this.selectCountryByName(this.addressData?.country);
                } else {
                    this.selectCountryByName("Bahrain");
                }
                if (this.country) {
                    if (this.addressData?.cityId) {
                        if (!this.selectCity(this.addressData?.cityId)) this.selectCityByName(this.addressData?.city);
                    } else if (this.addressData?.city) {
                        this.selectCityByName(this.addressData?.city);
                    }
                }
            }
        );
    }

    onCountryChange(event) {
        this.selectCountry(event.target?.value);
    }

    sortByCityName(cities) {
        if (!this.lang) return cities;

        return (_.isArray(cities)) ? cities.sort((a, b) => a.name[this.lang] > b.name[this.lang] ? 1 : a.name[this.lang] === b.name[this.lang] ? 0 : -1) : cities;
    }

    selectCountry(countryId) {
        this.country = _.find(this.countries, (countryObj) => { return countryObj._id == countryId; });
        if (this.country) {
            this.form.get('country').patchValue(this.country.name[this.lang]);
            this.form.get('countryId').patchValue(countryId);
        }
    }

    selectCountryByName(countryName) {
        this.country = _.find(this.countries, (countryObj) => { return countryObj.name.en == countryName || countryObj.name.ar == countryName; });
        if (this.country) {
            this.form.get('country').patchValue(this.country.name[this.lang]);
            this.form.get('countryId').patchValue(this.country._id);
        }
    }

    onCityChange(event) {
        this.selectCity(event.target?.value);

        if (this.isGuest) {
            this.changeCityEvent.emit();
        }
    }

    selectCity(cityId) {
        if (!cityId) return;
        let city;
        let area;
        _.each(this.country?.areas, (areaObj) => {
            city = _.find(areaObj.cities, (cityObj) => { return cityObj._id == cityId; });
            if (city) {
                area = areaObj;
                return false;
            }
        });
        if (area) {
            this.form.get('area').patchValue(area.name?.[this.lang]);
            this.form.get('areaId').patchValue(area._id);
        }
        if (city) {
            this.form.get('city').patchValue(city.name?.[this.lang]);
            this.form.get('cityId').patchValue(city._id);
            return true;
        }
        return false;
    }

    selectCityByName(cityName) {
        if (!cityName) return;
        let city;
        let area;
        _.each(this.country?.areas, (areaObj) => {
            city = _.find(areaObj.cities, (cityObj) => { return cityObj.name.en == cityName || cityObj.name.ar == cityName });
            if (city) {
                area = areaObj;
                return false;
            }
        });
        if (area) {
            this.form.get('area').patchValue(area.name?.[this.lang]);
            this.form.get('areaId').patchValue(area._id);
        }
        if (city) {
            this.form.get('city').patchValue(city.name?.[this.lang]);
            this.form.get('cityId').patchValue(city._id);
            return true;
        }
        return false;
    }

    fillForm() {
        if (!this.addressData?.location) {
            this.addressData.location = {};
        }
        this.form.patchValue(this.addressData)
    }

    mapCenter() {
        if (this.map) {
            var loc = this.map.getCenter();
            this.form.get("location").get("longitude").setValue(loc.lng());
            this.form.get("location").get("latitude").setValue(loc.lat());
            this.marker.position = {
                lat: loc.lat(),
                lng: loc.lng()
            }
        }
    }

    onPhoneKeyPress(event: KeyboardEvent): boolean {
        // Allow: backspace, delete, tab, escape, enter
        if ([46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
            // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
            (event.keyCode === 65 && event.ctrlKey === true) ||
            (event.keyCode === 67 && event.ctrlKey === true) ||
            (event.keyCode === 86 && event.ctrlKey === true) ||
            (event.keyCode === 88 && event.ctrlKey === true)) {
            return true;
        }
        // Only allow numbers 0-9
        const char = event.key;
        if (!/^[0-9]$/.test(char)) {
            event.preventDefault();
            return false;
        }
        return true;
    }

    onPhoneInput(event: any): void {
        const input = event.target as HTMLInputElement;
        const cleaned = input.value.replace(/[^0-9]/g, '');
        if (input.value !== cleaned) {
            this.form.get('phone')?.setValue(cleaned, { emitEvent: false });
            input.value = cleaned;
        }
    }

    onPhonePaste(event: ClipboardEvent): void {
        event.preventDefault();
        const pastedText = event.clipboardData?.getData('text') || '';
        const cleaned = pastedText.replace(/[^0-9]/g, '');
        const currentValue = this.form.get('phone')?.value || '';
        const input = event.target as HTMLInputElement;
        const start = input.selectionStart || 0;
        const end = input.selectionEnd || 0;
        const newValue = currentValue.substring(0, start) + cleaned + currentValue.substring(end);
        this.form.get('phone')?.setValue(newValue);
    }
}
